import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

export const customerTransitGuaranteesSchema = z.object({
  transitGuarantees: z.array(
    z.object({
      type: z.string().optional().nullable(),
      queryIdentifier: z.number().optional().nullable(),
      ownerId: z.string().optional().nullable(),
      holderId: z.string().optional().nullable(),
      masterAccessCode: z.string().optional().nullable(),
      accessCodeNew: z.string().optional().nullable(),
      reference: z.object({
        grn: z.string().optional().nullable(),
        accessCode: z.string().optional().nullable(),
        amountToBeCovered: z.string().optional().nullable(),
        currencyCode: z.string().optional().nullable(),
      }),
    }),
  ),
  requestForTransitGuarantee: z.object({
    periodFromDate: z.date().optional().nullable(),
    periodToDate: z.date().optional().nullable(),
    requesterRole: z.number().optional().nullable(),
  }),
});
export type CustomerViewTransitGuaranteesFormValues = z.infer<typeof customerTransitGuaranteesSchema>;

export const useCustomerViewTransitGuaranteesFormInitializer = ({ customerDetails }) => {
  const buildFormValues = (cd) => ({
    transitGuarantees: (cd?.transitGuarantees || []).map((transitGuarantee) => ({
      type: transitGuarantee.type,
      queryIdentifier: transitGuarantee.queryIdentifier ?? null,
      ownerId: transitGuarantee.ownerId ?? '',
      holderId: transitGuarantee.holderId ?? '',
      masterAccessCode: transitGuarantee.masterAccessCode ?? '',
      accessCodeNew: transitGuarantee.accessCodeNew ?? '',
      reference: {
        grn: transitGuarantee.reference?.grn ?? '',
        accessCode: transitGuarantee.reference?.accessCode ?? '',
        amountToBeCovered: transitGuarantee.reference?.amountToBeCovered ?? '',
        currencyCode: transitGuarantee.reference?.currencyCode ?? '',
      },
      customsQueryResponse: transitGuarantee.customsQueryResponse,
    })),
    requestForTransitGuarantee: {
      periodFromDate: cd?.requestForTransitGuarantee?.periodFromDate ? new Date(cd?.requestForTransitGuarantee?.periodFromDate) : null,
      periodToDate: cd?.requestForTransitGuarantee?.periodToDate ? new Date(cd?.requestForTransitGuarantee?.periodToDate) : null,
      requesterRole: cd?.requestForTransitGuarantee?.requesterRole ?? null,
    },
  });

  const form = useForm<CustomerViewTransitGuaranteesFormValues>({
    initialValues: buildFormValues(customerDetails),
    validate: zodResolver(customerTransitGuaranteesSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
